export default __webpack_public_path__ + "c4c75cbf29c67befa328a4df1f5906f6.png";